(
    function (skyward, $, undefined)
    {
        "use strict";

        skyward.familyAccessHeaderSelect = skyward.familyAccessHeaderSelect || {};

        $(function ()
        {
            var familyAccessHeaderSelect = $('#familyAccessHeaderSelect');

            if (familyAccessHeaderSelect.length === 0)
            {
                return;
            }

            var widthNeededToFitAllTiles = 0;
            var myAccountButton = $('#myAccountButton');
            var familyAccessHeaderSelectOffset = familyAccessHeaderSelect.offset();
            var moreButton = familyAccessHeaderSelect.find('.familyAccessHeaderSelectMore');
            var moreButtonWidth = moreButton.outerWidth(true);
            var menu;
            
            familyAccessHeaderSelect.find('.familyAccessHeaderSelectTile:not(.familyAccessHeaderSelectMore)').each(function ()
            {
                var tile = $(this);

                widthNeededToFitAllTiles += tile.outerWidth(true);
            });

            familyAccessHeaderSelect.on('click', '.familyAccessHeaderSelectTile:not(.familyAccessHeaderSelectMore)', function ()
            {
                familyAccessHeaderSelect.find('.familyAccessHeaderSelectTile.selected').removeClass('selected');
                $(this).addClass('selected');
            });

            var resize = function ()
            {
                if (menu)
                {
                    menu.close();
                }

                var tiles = familyAccessHeaderSelect.find('.familyAccessHeaderSelectTile:not(.familyAccessHeaderSelectMore, .familyAccessHeaderSelectTile.selected)');
                var widthAvailable = myAccountButton.offset().left - familyAccessHeaderSelectOffset.left;

                tiles.removeClass('hidden');

                var tilesHidden = false;

                if (widthAvailable < widthNeededToFitAllTiles)
                {
                    widthAvailable -= moreButtonWidth;
                    widthAvailable -= familyAccessHeaderSelect.find('.familyAccessHeaderSelectTile.selected').first().outerWidth(true);

                    for (var i = 0; i < tiles.length; i++)
                    {
                        var tile = $(tiles[i]);
                        var tileWidth = tile.outerWidth(true);

                        if (!tilesHidden && widthAvailable >= tileWidth)
                        {
                            widthAvailable -= tileWidth;
                        }
                        else
                        {
                            tile.addClass('hidden');
                            tilesHidden = true;
                        }
                    }
                }

                if (tilesHidden)
                {
                    moreButton.show();
                }
                else
                {
                    moreButton.hide();
                }
            };

            resize();
            skyward.window.registerLayoutResizeCallback(resize);
            
            moreButton.click(function ()
            {
                var menuItems = [];
                
                menuItems.push({ type: "title", text: "More Students" });

                familyAccessHeaderSelect.find('.familyAccessHeaderSelectTile.hidden:not(.familyAccessHeaderSelectMore)').each(function ()
                {
                    menuItems.push(createMenuItemDefinition($(this)));
                });

                menu = skyward.modalLayer.showMenu(menuItems, moreButton);

                function createMenuItemDefinition(tile)
                {
                    var icon = tile.find('img');
                    if (icon.length === 0)
                    {
                        icon = tile.find('svg');
                    }

                    var menuItemDefinition =
                    {
                        type: 'item',
                        click: function ()
                        {
                            tile.click();
                        },
                        icon: icon,
                        disabled: false
                    };

                    menuItemDefinition.text = "";
                    tile.find("label").each(function ()
                    {
                        menuItemDefinition.text += $(this).html() + ' ';
                    });

                    return menuItemDefinition;
                }
            });
        });

        var updateWindowStudentGuardian = function ()
        {
            var data = $(this).data();
            
            var module = data.redirectModule !== undefined && data.redirectModule !== null ? data.redirectModule : data.redirectmodule;
            var object = data.redirectObject !== undefined && data.redirectObject !== null ? data.redirectObject : data.redirectobject;
            var screen = data.redirectScreen !== undefined && data.redirectScreen !== null ? data.redirectScreen : data.redirectscreen;
            var id = data.studentid;
            var loadDifferentPage =
                module !== undefined && module !== null &&
                object !== undefined && object !== null &&
                screen !== undefined && screen !== null &&
                id !== undefined && id !== null;
            var url = skyward.global.virtualDir + 'Security/Window/UpdateStudentGuardian';

            $.ajax(
            {
                url: url,
                type: "POST",
                data: data,
                  
                success: function (result)
                {
                    if (result.success)
                    {
                        if (loadDifferentPage)
                        {
                            skyward.window.loadContent("full", module, object, screen, id, data);
                        }
                        else
                        {
                            window.location.reload(true);
                        }
                    }
                }
            });
        };

        var events =
        {
            'updateWindowStudentGuardian': updateWindowStudentGuardian
        };
        skyward.events.registerEvents('familyAccessHeaderSelect', events);

    }(window.skyward = window.skyward || {}, window.jQuery)
);